<div class="p-3 pt-2 rounded-4">

  <!-- Header -->
  <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between align-items-center">
    <div class="p-3 d-flex align-items-center gap-2">
      <button class="btn btn-sm btn-primary rounded-pill" (click)="goBack()">
        <i class="bi bi-arrow-left"></i> Back
      </button>
      <span>Customer Details</span>
    </div>
  </div>

  <!-- Loading -->
  @if (isLoading) {
    <div class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted">Loading customer details...</p>
    </div>
  }

  <!-- Content -->
  @if (!isLoading && selectedCustomer) {
    <div class="container-fluid">
      <div class="row bg-white p-3 rounded-4 mt-2">
        <!-- Basic Info -->
        <div class="col-md-12 mb-3">
          <h5 class="btn btn-primary mt-2 text-start bg-primary-subtle text-primary border-0 w-100">
            Basic Information
          </h5>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Customer Name</div>
            <div class="col-7">: {{ selectedCustomer.name }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Email Id</div>
            <div class="col-7 text-break">: {{ selectedCustomer.emailId }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Date of Birth</div>
            <div class="col-7">: {{ formatDob(selectedCustomer.dob, selectedCustomer.citizenshipCountry?.dobFormat || selectedCustomer.country?.dobFormat) }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Mobile</div>
            <div class="col-7">: {{ formatMobile(selectedCustomer.mobile) }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Country</div>
            <div class="col-7">: {{ selectedCustomer.country?.displayName }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Created At</div>
            <div class="col-7">: {{ dateFormat(selectedCustomer.createdAt) }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Citizenship</div>
            <div class="col-7">: {{ selectedCustomer?.citizenshipCountry?.displayName || '—' }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Current Destination</div>
            <div class="col-7">: {{ selectedCustomer?.destinationCountry?.displayName || '—' }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Account Status</div>
            <div class="col-7 d-flex align-items-center gap-2">
              :
              <span class="badge"
                [ngClass]="selectedCustomer.deletedByCustomer ? 'bg-warning' : (selectedCustomer.isFrozen ? 'bg-danger' : 'bg-success')">
                <i class="bi"
                [ngClass]="selectedCustomer.deletedByCustomer ? 'bi-trash' : (selectedCustomer.isFrozen ? 'bi-lock' : 'bi-check-circle')"></i>
                {{ selectedCustomer.deletedByCustomer ? 'DELETED' : (selectedCustomer.isFrozen ? 'FROZEN' : 'ACTIVE') }}
              </span>
              @if (!selectedCustomer.deletedByCustomer && selectedCustomer._id && (_auth.userObj?.role === 'Admin' || _auth.userObj?.role === 'Super Admin')) {
                <button
                  class="btn btn-sm rounded-pill"
                  [ngClass]="selectedCustomer.isFrozen ? 'btn-success' : 'btn-danger'"
                  (click)="toggleAccountStatus(selectedCustomer)">
                  <i class="bi bi-{{ selectedCustomer.isFrozen ? 'unlock' : 'lock' }}"></i>
                  {{ selectedCustomer.isFrozen ? 'Unfreeze' : 'Freeze' }} Account
                </button>
              }
            </div>
          </div>
        </div>
        <!-- KYC Details -->
        <div class="col-md-12 mt-3 mb-3">
          <h5 class="btn btn-primary text-start bg-primary-subtle text-primary border-0 w-100">
            KYC Details
          </h5>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Driving Licence No.</div>
            <div class="col-7">: {{ customerData?.kyc?.drivingLicenceNumber || '—' }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Passport Number</div>
            <div class="col-7">: {{ customerData?.kyc?.passportNumber || '—' }}</div>
          </div>
        </div>
        <!-- Documents -->
        <div class="col-md-12 mt-3 mb-3">
          <h5 class="btn btn-primary text-start bg-primary-subtle text-primary border-0 w-100">
            Documents
          </h5>
        </div>
        <div class="col-md-4 mb-3">
          <p class="text-muted fw-semibold mb-1">Driving Licence</p>
          @if (customerData?.kyc?.drivingLicenceImage) {
            <button type="button"
              class="btn btn-sm btn-outline-primary"
              (click)="getImage(customerData?.kyc?.drivingLicenceImage)">
              <i class="bi bi-eye me-1"></i> View
            </button>
          }
          @if (!customerData?.kyc?.drivingLicenceImage) {
            <span class="text-muted">Not available</span>
          }
        </div>
        <div class="col-md-4 mb-3">
          <p class="text-muted fw-semibold mb-1">Passport</p>
          @if (customerData?.kyc?.passportImage) {
            <button type="button"
              class="btn btn-sm btn-outline-primary"
              (click)="getImage(customerData?.kyc?.passportImage)">
              <i class="bi bi-eye me-1"></i> View
            </button>
          }
          @if (!customerData?.kyc?.passportImage) {
            <span class="text-muted">Not available</span>
          }
        </div>
        <div class="col-md-4 mb-3">
          <p class="text-muted fw-semibold mb-1">Selfie</p>
          @if (customerData?.kyc?.selfieImage) {
            <button type="button"
              class="btn btn-sm btn-outline-primary"
              (click)="getImage(customerData?.kyc?.selfieImage)">
              <i class="bi bi-eye me-1"></i> View
            </button>
          }
          @if (!customerData?.kyc?.selfieImage) {
            <span class="text-muted">Not available</span>
          }
        </div>
        @if (selectedCustomer.customerStatus === 'Approved') {
        <!-- Account Details -->
        <div class="col-md-12 mt-3 mb-3">
          <h5 class="btn btn-primary text-start bg-primary-subtle text-primary border-0 w-100">
            Account Details
          </h5>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Account Name</div>
            <div class="col-7">: {{ customerData?.partnerName||customerData?.account?.partnerId?.name || '—' }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Account Number</div>
            <div class="col-7">: {{ customerData?.account?.accountNumber || '—' }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Routing Number</div>
            <div class="col-7">: {{ customerData?.account?.routingNumber || '—' }}</div>
          </div>
        </div>
        }
        <!-- Beneficiaries -->
        <div class="col-md-12 mt-3 mb-3">
          <h5 class="btn btn-primary text-start bg-primary-subtle text-primary border-0 w-100">
            Beneficiaries
          </h5>
        </div>
        @if (beneficiaries.length === 0) {
          <div class="col-md-12">
            <p class="text-muted">No beneficiaries found for this customer.</p>
          </div>
        }
        @if (beneficiaries.length > 0) {
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-bordered table-hover align-middle">
                <thead class="table-light">
                  <tr>
                    <th>#</th>
                    <th>Beneficiary Name</th>
                    <th>Account Number</th>
                    <th>Mobile Number</th>
                    <th>Bank Details</th>
                    <th>Status</th>
                    <th>Action</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  @for (b of beneficiaries; track b; let i = $index) {
                    <tr>
                      <td>{{ i + 1 }}</td>
                      <td>{{ b.beneficiaryName }}</td>
                      <td>{{ b.accountNumber || b.billerId?.bankAccount?.accountNumber || getFirstFieldValue(b.customerFields) || getFirstCustomerFieldValue() || '—' }}</td>
                      <td>{{ formatBeneficiaryMobile(b.mobileNumber, b) }}</td>
                      <td>
                        @if (!b.isBill && b.dynamicFields) {
                          <div>
                            @for (key of getDynamicFieldKeys(b.dynamicFields); track key) {
                              <div class="small">
                                <span class="text-muted">{{ key }}:</span> {{ b.dynamicFields[key] }}
                              </div>
                            }
                          </div>
                        }
                        @if (b.isBill && b.billerId?.bankAccount) {
                          <div>
                            <div class="small">
                              <span class="text-muted">Bank:</span> {{ b.billerId.bankAccount.bankName }}
                            </div>
                            <div class="small">
                              <span class="text-muted">SWIFT:</span> {{ b.billerId.bankAccount.swiftCode }}
                            </div>
                          </div>
                        }
                      </td>
                      <td>
                        <span class="badge" [ngClass]="b.isActive ? 'bg-success' : 'bg-danger'">
                          {{ b.isActive ? 'Active' : 'Inactive' }}
                        </span>
                      </td>
                      <td>
                        <button class="btn btn-sm btn-primary active rounded-pill" (click)="viewBeneficiaryTransactions(b)">
                          <i class="bi bi-eye-fill"></i>
                        </button>
                      </td>
                      <td>{{ dateFormat(b.createdAt) }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
        @if (selectedCustomer.customerStatus === 'Approved') {
        <!-- Credit Balance -->
        <div class="col-md-12 mt-3 mb-3">
          <h5 class="btn btn-primary text-start bg-primary-subtle text-primary border-0 w-100">
            Balance & Credit
          </h5>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Current Balance</div>
            <div class="col-7">: {{ (customerData?.account?.balance ?? 0) | number:'1.2-2' }} {{ customerData?.account?.currencySymbol || 'EUR' }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="row">
            <div class="col-5 text-muted fw-semibold">Spending</div>
            <div class="col-7">: {{ (customerData?.account?.spending ?? 0) | number:'1.2-2' }} {{ customerData?.account?.currencySymbol || 'EUR' }}</div>
          </div>
        </div>
        <div class="col-md-12 mb-3 mt-2">
          <button class="btn btn-sm btn-success rounded-pill" (click)="openCreditBalanceModal()">
            <i class="bi bi-plus-circle me-1"></i> Credit Balance
          </button>
        </div>
        }
      </div>
    </div>
  }

  <!-- No data -->
  @if (!isLoading && !selectedCustomer) {
    <div class="text-center py-5 text-muted">
      <i class="bi bi-person-x fs-1"></i>
      <p class="mt-2">Customer not found.</p>
      <button class="btn btn-primary rounded-pill" (click)="goBack()">Go Back</button>
    </div>
  }

</div>

<!-- Freeze/Unfreeze Modal -->
<ng-template #freezeModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ freezeModalData?.isFrozen ? 'Unfreeze Account' : 'Freeze Account' }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeFreezeModal()"></button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label">Customer ID:</label>
      <input type="text" class="form-control" [value]="freezeModalData?.customerId" readonly>
    </div>
    <div class="mb-3">
      <label class="form-label">Customer Name:</label>
      <input type="text" class="form-control" [value]="freezeModalData?.customerName" readonly>
    </div>
    <div class="mb-3">
      <label class="form-label">Reason <span class="text-danger">*</span></label>
      <select class="form-select" [(ngModel)]="freezeReason" required>
        <option value="">Select a reason</option>
        <option value="Lost mobile device">Lost mobile device</option>
        <option value="Stolen device">Stolen device</option>
        <option value="Suspected fraud">Suspected fraud</option>
        <option value="Security concern">Security concern</option>
        <option value="Unauthorized transactions">Unauthorized transactions</option>
        <option value="Compromised account">Compromised account</option>
        <option value="Other">Other</option>
      </select>
    </div>
    @if (freezeReason === 'Other') {
      <div class="mb-3">
        <label class="form-label">Specify Reason</label>
        <input type="text" class="form-control" [(ngModel)]="otherReason" placeholder="Enter specific reason">
      </div>
    }
    <div class="mb-3">
      <label class="form-label">Additional Notes</label>
      <textarea class="form-control" rows="3" [(ngModel)]="freezeNote" placeholder="Additional details (optional)"></textarea>
    </div>
    @if (freezeModalData?.isFrozen) {
      <div class="alert alert-warning">
        <strong>Warning:</strong> This will unfreeze the account and allow transactions to resume.
      </div>
    }
    @if (!freezeModalData?.isFrozen) {
      <div class="alert alert-danger">
        <strong>Warning:</strong> This will freeze the account and block all transactions until unfrozen.
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeFreezeModal()">Cancel</button>
    <button type="button"
      class="btn btn-{{ freezeModalData?.isFrozen ? 'success' : 'danger' }}"
      [disabled]="!freezeReason || (freezeReason === 'Other' && !otherReason)"
      (click)="confirmFreezeAction()">
      {{ freezeModalData?.isFrozen ? 'Unfreeze Account' : 'Freeze Account' }}
    </button>
  </div>
</ng-template>

<!-- Credit Balance Modal -->
<ng-template #creditBalanceModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Credit Customer Balance</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeCreditBalanceModal()"></button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label">Customer ID</label>
      <input type="text" class="form-control" [value]="customerId" readonly>
    </div>
    <div class="mb-3">
      <label class="form-label">Customer Name</label>
      <input type="text" class="form-control" [value]="selectedCustomer?.name" readonly>
    </div>
    <div class="mb-3">
      <label class="form-label">Amount <span class="text-danger">*</span></label>
      <input type="number" class="form-control" [(ngModel)]="creditAmount" min="0.01" step="0.01" placeholder="Enter amount">
    </div>
    <div class="mb-3">
      <label class="form-label">Reason</label>
      <textarea class="form-control" rows="2" [(ngModel)]="creditReason" placeholder="Reason for credit (optional)"></textarea>
    </div>
    <div class="mb-3">
      <label class="form-label">Admin Password <span class="text-danger">*</span></label>
      <input type="password" class="form-control" [(ngModel)]="creditPassword" placeholder="Enter your password to confirm">
    </div>
    @if (creditError) {
      <div class="alert alert-danger">{{ creditError }}</div>
    }
    @if (creditSuccess) {
      <div class="alert alert-success">{{ creditSuccess }}</div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeCreditBalanceModal()">Cancel</button>
    <button type="button"
      class="btn btn-success"
      [disabled]="!creditAmount || creditAmount <= 0 || !creditPassword || isCrediting"
      (click)="confirmCreditBalance()">
      {{ isCrediting ? 'Crediting...' : 'Credit Balance' }}
    </button>
  </div>
</ng-template>
